<div class="container page-section-one">
    <div class="row align-items-center py-5">
        <div class="col-12">
            <app-form [inputForm]="activateAccessForm"></app-form>
        </div>
    </div>
</div>
<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>
